import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { InfoBoxBoxProps, lightInfoBox } from './info-box.style';
import { spacing12 } from 'approot/shared/styles/spacing.style';
import { richtextCommonCss } from 'approot/shared/richtext/richtext.style';

export const InfoBoxStatement = styled.div<InfoBoxBoxProps>`
  ${lightInfoBox}

  .ProseMirror {
    background-color: transparent;
    padding: ${rem(spacing12)};
  }
`;

export const InfoBoxStatementView = styled.div<InfoBoxBoxProps>`
  ${lightInfoBox}
  ${richtextCommonCss}
  padding: ${rem(spacing12)};
`;
